/**
 * Personal/disposable email providers we don't accept on lead-capture forms
 * that ask for a work email. Mirrors the server-side allowlist in
 * `vite.config.ts` so the user gets immediate feedback before submitting.
 */
export const PERSONAL_EMAIL_DOMAINS: ReadonlySet<string> = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.uk",
  "ymail.com",
  "hotmail.com",
  "hotmail.co.uk",
  "outlook.com",
  "live.com",
  "msn.com",
  "aol.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "proton.me",
  "protonmail.com",
  "pm.me",
  "yandex.com",
  "yandex.ru",
  "gmx.com",
  "gmx.de",
  "mail.com",
  "mail.ru",
  "zoho.com",
  "fastmail.com",
  "hey.com",
]);

export function isPersonalEmail(email: string): boolean {
  const at = email.lastIndexOf("@");
  if (at === -1) return false;
  return PERSONAL_EMAIL_DOMAINS.has(email.slice(at + 1).toLowerCase());
}

export const WORK_EMAIL_MESSAGE =
  "Please use your work email address — personal email providers are not accepted.";
